import { Capacitor } from "@capacitor/core";
import { openExternalUrl } from "./open-external-url";

const IOS_APP_ID = "6749600727";
const ANDROID_APP_ID = "uk.co.nutricoach.app";

export const openAppRating = () => {
  const platform = Capacitor.getPlatform();

  if (platform === "ios") {
    openExternalUrl(`itms-apps://itunes.apple.com/app/id${IOS_APP_ID}?action=write-review`);
    return;
  }

  if (platform === "android") {
    openExternalUrl(`https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}`);
  }
  // web: no-op
};
